module.exports = __webpack_public_path__ + "img/login_bg2.18e804de.jpg";